import { withStyles } from '@material-ui/core/styles';
import MuiGrid from '@material-ui/core/Grid';
import MuiTypography from '@material-ui/core/Typography';
import CreateQuery from './create-query';
import { useQuery } from 'react-query';
import * as API from 'api';
import AvailableQuery from './available-query';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiBox from '@material-ui/core/Box';
import QueryPagination from './query-pagination';
import { useState } from 'react';

const QueryLibrary = API.QueryLibrary();

const styles = theme => ({
  header: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontWeight: 'normal',
  },
  queries: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
});

const AvailableQueries = ({ ...props }) => {
  const { classes } = props;
  const [params, setParams] = useState({
    page_index: 0,
    page_size: 10,
  });
  const { data, isLoading, refetch, isRefetching } = useQuery(
    ['query-library-prompts', params.page_index, params.page_size],
    () => {
      return QueryLibrary.getQueryLibraryPrompts({
        page_index: params.page_index,
        page_size: params.page_size,
      });
    }
  );

  const handlePageChange = page => {
    setParams({ ...params, page_index: page });
    refetch();
  };

  return (
    <MuiBox>
      {(isLoading || isRefetching) && <MuiCircularProgress />}
      {!isLoading && !isRefetching && (
        <MuiBox>
          <MuiGrid item xs={12} container justifyContent="space-between" alignItems="center" className={classes.header}>
            <MuiTypography className={classes.subtitle} variant="h6">
              Available queries
            </MuiTypography>
            <CreateQuery refetch={refetch} />
          </MuiGrid>
          {data.results?.length === 0 && <MuiTypography variant="body1">No queries found</MuiTypography>}
          {data.results?.length > 0 && (
            <MuiBox>
              <MuiBox className={classes.queries}>
                {data.results?.map(query => (
                  <AvailableQuery key={query.query_library_prompt_id} {...query} refetch={refetch} />
                ))}
              </MuiBox>
              <QueryPagination
                page={params.page_index}
                totalItems={data.total}
                itemsPerPage={params.page_size}
                handlePageChange={handlePageChange}
              />
            </MuiBox>
          )}
        </MuiBox>
      )}
    </MuiBox>
  );
};

export default withStyles(styles)(AvailableQueries);
